export { default } from './ModalAgeVerification';
